import { ExportType } from '../../views/report-details/interfaces/report-details.interface';

export const LARGE_DATASET_EXPORT_RECORD_LIMIT = 1_048_576;

const LARGE_DATASET_RESTRICTED_EXPORT_TYPES = new Set<string>(['excel', 'google_sheet', 'xlsx']);

export const LARGE_DATASET_CSV_EXPORT_TITLE = 'Export Format Not Available';

export const LARGE_DATASET_CSV_EXPORT_MESSAGE =
  `Excel and Google Sheets exports are not available for reports exceeding ${LARGE_DATASET_EXPORT_RECORD_LIMIT.toLocaleString()} records. To export this dataset, please use CSV format.`;

export function isLargeDataset(totalRecords: number): boolean {
  return totalRecords > LARGE_DATASET_EXPORT_RECORD_LIMIT;
}

export function isExportRestrictedForLargeDataset(exportType: ExportType | string, totalRecords: number): boolean {
  return isLargeDataset(totalRecords) && LARGE_DATASET_RESTRICTED_EXPORT_TYPES.has(exportType);
}
